import { Component, OnInit, OnDestroy, AfterViewInit, Input, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { URLS } from 'src/app/constants/URLS';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { ReportModalComponent } from '../report-modal/report-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { ShareModalComponent } from '../share-modal/share-modal.component';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { environment } from 'src/environments/environment';
import { getAppBasePath } from 'src/app/utils/share-link.utils';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { getVideoStreamFile } from 'src/app/utils/media-url.utils';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { TVNavigationService, Region } from 'src/app/_service/tv-navigation.service';

interface Video {
  vidLibId: string;
  title: string;
  channelId: string;
  channel_desc: string;
  views?: number;
  vidLike?: number;
  videoDuration: string;
  modifiedDate?: string;
  isInWatchList?: boolean;
}

@Component({
  selector: 'app-cc-prime-thumbnail',
  templateUrl: './cc-prime-thumbnail.component.html',
  styleUrls: ['./cc-prime-thumbnail.component.css']
})
export class CcPrimeThumbnailComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() videos: Video[] = [];
  @Input() rowId?: string;

  @ViewChild('gridContainer') gridContainer!: ElementRef;
  @ViewChildren('videoCard') cardRefs!: QueryList<ElementRef>;

  appComponent: any;
  imgUrl: string = URLS.imgUrl;
  channelUrl: string = URLS.channelUrl;
  downloadingToast: boolean = false;
  loaderShowHide: any;
  progressBarId: any;

  // TV Navigation state
  private generatedRegionId?: string;
  private focusSubscription?: Subscription;
  private cardsSubscription?: Subscription;
  focusedCardIndex = -1;

  private destroy$ = new Subject<void>();

  constructor(
    private mycontentservice: MycontentserviceService,
    private dialog: MatDialog,
    private toastrService: CustomControlsService,
    private router: Router,
    private whitelabelService: WhiteLabelService,
    private bridgeService: IosBridgeService,
    private axinomService: AxinomDrmService,
    private device: DeviceService,
    private tvNav: TVNavigationService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // TV Navigation registration
    console.log('[CcPrimeThumbnail] ngAfterViewInit - isTV:', this.device.isTV(), 'cardRefs:', this.cardRefs?.length);
    if (this.device.isTV()) {
      setTimeout(() => {
        console.log('[CcPrimeThumbnail] Registering with navigation, cardRefs:', this.cardRefs?.length);
        this.registerWithNavigation();
      }, 100);

      this.cardsSubscription = this.cardRefs?.changes.subscribe(() => {
        console.log('[CcPrimeThumbnail] cardRefs changed, re-registering');
        this.registerWithNavigation();
      });

      this.focusSubscription = this.tvNav.focus$.subscribe(focusKey => {
        const regionId = this.rowId || this.generatedRegionId;
        if (focusKey && regionId && focusKey.startsWith(`${regionId}:`)) {
          this.focusedCardIndex = parseInt(focusKey.split(':')[1], 10);
        } else {
          this.focusedCardIndex = -1;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    // TV Navigation cleanup
    if (this.device.isTV()) {
      const regionId = this.rowId || this.generatedRegionId;
      if (regionId) {
        this.tvNav.unregisterRegion(regionId);
      }
    }
    this.focusSubscription?.unsubscribe();
    this.cardsSubscription?.unsubscribe();
  }

  private registerWithNavigation(): void {
    if (!this.cardRefs || this.cardRefs.length === 0) {
      console.log('[CcPrimeThumbnail] No cardRefs, skipping registration');
      return;
    }
    if (!this.gridContainer) {
      console.log('[CcPrimeThumbnail] No gridContainer, skipping registration');
      return;
    }

    // Generate unique ID if not provided
    if (!this.rowId && !this.generatedRegionId) {
      this.generatedRegionId = `cc-prime-thumbnail-${Date.now()}`;
    }

    const regionId = this.rowId || this.generatedRegionId;
    if (!regionId) return;

    const region: Region = {
      id: regionId,
      type: 'row',
      elementRef: this.gridContainer,
      focusableItems: this.cardRefs.toArray()
    };
    console.log('[CcPrimeThumbnail] Calling registerRegion:', regionId, 'items:', this.cardRefs.length);
    this.tvNav.registerRegion(region);
  }

  openPlayer(video: any, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    const win = window as any;
    const route = this.whitelabelService.getPrefixedRoute('watch');
    console.log("consoling my logs", win?.AndroidTv);
    console.log("is openVideoPlayer available", win?.AndroidTv?.openVideoPlayer);
    if(win?.AndroidTV && typeof win.AndroidTV.openVideoPlayer === 'function') {
      console.log("you are in android tv");
      const payload = {
        videoUrl: `${environment.baseUrl}toqqer/static/post_videos/${getVideoStreamFile(video)}`,
        drmLicenseUrl: this.axinomService.getWidevineUrl(),
        authToken: this.axinomService.getWidevineToken(),
        videoLibrary: video
      }
      console.log('vids json', payload);
      win.AndroidTV.openVideoPlayer(JSON.stringify(payload));
      return;
    }
    if (this.bridgeService.isIOS()) {
      console.log("you are insdie the ios");
      const payload = {
        video,
        returnRoute: this.router.url,
        playerUrl: `${this.bridgeService.getCurrentDomain()}${route}`,
      };
      this.bridgeService.openVideoPlayer(payload);
      return;
    }
    console.log("you areoutside the android tv or ios");
    this.router.navigate([route], {
      queryParams: { ref: video?.vidLibId }
    });
  }
  
  getChannelInitial(video: any): string {
    const desc = video?.channel_desc?.trim() || '';
    const cleaned = desc.startsWith('@') ? desc.slice(1) : desc;
    for (let char of cleaned) {
      if (/[a-zA-Z0-9]/.test(char)) {
        return char.toUpperCase();
      }
    }
    return '?'; 
  }
  
  trackByVideoId(index: number, video: Video): string {
    return video.vidLibId;
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  onImageError(event: any): void {
    event.target.src = './assets/img/thumbnail.png';
  }

  addVideoToWatchList(vidLibId: string, video: Video): void {
    const userId = localStorage.getItem('userId');
    if (!userId) return;

    this.mycontentservice.addInWatchList(userId, vidLibId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        console.log(result);
        video.isInWatchList = true;
        this.showSuccess('Video added to queue');
      });
  }

  removeVideoFromWatchList(vidLibId: string, video: Video): void {
    const userId = localStorage.getItem('userId');
    if (!userId) return;

    this.mycontentservice.removeFromWatchList(userId, vidLibId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        console.log(result);
        video.isInWatchList = false;
        this.showSuccess('Video removed from queue');
      });
  }

  showSuccess(message: string): void {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  showReportTypes(video: Video): void {
    const dialogRef = this.dialog.open(ReportModalComponent, {
      panelClass: 'subscription-dialog',
      data: {
        vidLibId: video.vidLibId
      },
    });    

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  openShareModal(video: Video): void {
    let videoLink = `${environment.baseUrl}cms/s/${video.vidLibId}`;
    const params: string[] = [];
    if (this.whitelabelService.isWhiteLabel()) {
      const channel = (this.whitelabelService.channel || '').replace('@', '');
      const entry = this.whitelabelService.entryType || 'f';
      params.push(`c=${channel}`, `e=${entry}`);
    }
    const basePath = getAppBasePath();
    if (basePath) {
      params.push(`p=${encodeURIComponent(basePath)}`);
    }
    if (params.length) {
      videoLink += '?' + params.join('&');
    }
    if (navigator.share) {
      navigator.share({
        title: video?.title || 'Check out this video',
        url: videoLink
      }).catch(() => {});
    } else {
      this.dialog.open(ShareModalComponent, {
        data: { videoLink },
      });
    }
  }

  getAspectRatio(video: any): string {
    if (window.innerWidth >= 768) {
      return '16 / 9';
    }
    if (!video.aspectRatio) return '16 / 9';
    const parts = video.aspectRatio.split(',');
    if (parts.length < 3) return '16 / 9';
    const width = parseInt(parts[0], 10);
    const height = parseInt(parts[1], 10);
    const orientation = parts[2];
    if (orientation === 'V' && width > 0 && height > 0) {
      return `${width} / ${height}`; 
    }
    return '16 / 9';
  }

  goToChannel(video){
    const route = this.whitelabelService.getPrefixedRoute('channel', 'user');
    console.log(route)
    this.router.navigate([route], {
      queryParams: {
        channelId: video.channelId,
        category: 'CC_PRIME'
      }
    });
  }
}